<template>
  <input
    :id="id"
    :aria-label="placeholderLabel + ' input'"
    :type="type"
    :value="value"
    :disabled="disabled"
    :autofocus="autofocus"
    :name="name"
    :autocomplete="autocomplete"
    :pattern="pattern"
    :inputmode="inputmode"
    :maxlength="maxlength"
    :minlength="minlength"
    :required="required"
    class="c-input"
    :class="{
      [`c-input--${type}`]: type,
      'c-input--has-value': value && value.length > 0,
      [`c-input--${size}`]: size,
    }"
    @input="
      $emit('update:model-value', ($event.target as HTMLInputElement).value)
    "
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @keydown="$emit('keydown', $event)"
    @paste="$emit('paste', $event)"
  />
</template>

<script setup lang="ts">
interface Props {
  value?: string
  name?: string
  disabled?: boolean
  autofocus?: boolean
  autocomplete?: string
  pattern?: string
  inputmode?: 'search' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal'
  maxlength?: number
  minlength?: number
  size?: 'small' | 'medium' | 'large'
  required?: boolean
  type:
    | 'text'
    | 'number'
    | 'email'
    | 'url'
    | 'tel'
    | 'search'
    | 'password'
    | 'hidden'
  id?: string
  placeholderLabel?: string
}

withDefaults(defineProps<Props>(), {
  minlength: undefined,
  maxlength: undefined,
  inputmode: undefined,
  id: undefined,
  name: undefined,
  pattern: undefined,
  autocomplete: undefined,
  value: '',
  size: 'medium',
  placeholderLabel: '',
})

defineEmits<{
  (e: 'update:model-value', value: string): void
  (e: 'focus', event: Event): void
  (e: 'blur', event: Event): void
  (e: 'keydown', event: KeyboardEvent): void
  (e: 'paste', event: Event): void
}>()
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CInput',
})
</script>
